import { last } from 'lodash';

import { Bankruptcy, BankruptcyStatus } from '@willow/graphql-iso/src/app';
import { assertNever, LoanReportingBankruptcyChapter } from '@willow/types-iso';

// Structural constraint: any record with `status` + `endDate` is enough.
// Generic preserves the caller's row type so consumers can read fields like
// `chapter` from the returned value without re-narrowing.
type ActiveBankruptcyShape = Pick<Bankruptcy, 'status' | 'endDate'>;
export const getActiveBankruptcy = <T extends ActiveBankruptcyShape>(bankruptcies?: T[] | null): T | undefined => {
  if (bankruptcies == null) return undefined;
  return last(
    bankruptcies.filter((bankruptcy) =>
      bankruptcy.status ? bankruptcy.status === BankruptcyStatus.Active : bankruptcy.endDate == null,
    ),
  );
};

export const formatBankruptcyChapterFilterLabel = (bankruptcyChapter: LoanReportingBankruptcyChapter) => {
  switch (bankruptcyChapter) {
    case 'CHAPTER_7':
      return 'Ch 7';
    case 'CHAPTER_11':
      return 'Ch 11';
    case 'CHAPTER_12':
      return 'Ch 12';
    case 'CHAPTER_13':
      return 'Ch 13';
    case 'NONE':
      return 'None';
    default:
      return assertNever(bankruptcyChapter);
  }
};

export const formatBankruptcyChapterShort = (bankruptcyChapter: LoanReportingBankruptcyChapter) => {
  switch (bankruptcyChapter) {
    case 'CHAPTER_7':
      return 'Ch 7';
    case 'CHAPTER_11':
      return 'Ch 11';
    case 'CHAPTER_12':
      return 'Ch 12';
    case 'CHAPTER_13':
      return 'Ch 13';
    case 'NONE':
      return '';
    default:
      return assertNever(bankruptcyChapter);
  }
};

export const formatBankruptcyChapter = (bankruptcyChapter: LoanReportingBankruptcyChapter) => {
  switch (bankruptcyChapter) {
    case 'CHAPTER_7':
      return 'Chapter 7';
    case 'CHAPTER_11':
      return 'Chapter 11';
    case 'CHAPTER_12':
      return 'Chapter 12';
    case 'CHAPTER_13':
      return 'Chapter 13';
    case 'NONE':
      return '';
    default:
      return assertNever(bankruptcyChapter);
  }
};

export const formatBankruptcyChapterLong = (bankruptcyChapter: LoanReportingBankruptcyChapter) => {
  switch (bankruptcyChapter) {
    case 'CHAPTER_7':
      return 'Chapter 7 Bankruptcy';
    case 'CHAPTER_11':
      return 'Chapter 11 Bankruptcy';
    case 'CHAPTER_12':
      return 'Chapter 12 Bankruptcy';
    case 'CHAPTER_13':
      return 'Chapter 13 Bankruptcy';
    case 'NONE':
      return '';
    default:
      return assertNever(bankruptcyChapter);
  }
};
